<template>
    <div>
        <div v-if="isMobile" class="custom-header-menu d-flex justify-content-end flex-wrap flex-md-nowrap">
            <div class="custom-header-menu__logo" >
                <a :title="'Redirect on Dashboard page'" class="navbar-brand sidebar_logo_well" :href="homeUrl">
                    <img :src="logoUrl" alt="CRBG Logo">
                </a>
                <button @click="setShowBurgerMenu(!showBurgerMenu)" class="navbar-toggler" type="button">
                    <span class="navbar-toggler-icon"></span>
                </button>

<!--            <a title="Redirect on Dashboard page" class="navbar-brand" href="{{ url('/') }}">-->
<!--                <img src="{{url('images/CRBG_Logo_with_text.png')}}" class="header_logo_well" alt="CRBG Logo">-->
<!--            </a>-->
<!--            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="{{ __('Toggle navigation') }}">-->
<!--                <span class="navbar-toggler-icon"></span>-->
<!--            </button>-->
            </div>
         </div>
        <header-menu-component v-if="!isMobile"></header-menu-component>
    </div>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
    name: 'HeaderNavigateComponent',
    data() {
        return {
            homeUrl: '/',
            logoUrl: '/images/crbg/logo-compass-rose-health-plan.svg',
            isMobile: false
        }
    },
    mounted() {
        this.checkIsMobile()
        window.addEventListener('resize', this.checkIsMobile)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkIsMobile)
    },
    computed: {
        ...mapState('navigation', ['showBurgerMenu']),
    },
    methods: {
        ...mapActions('navigation', ['setShowBurgerMenu']),
        checkIsMobile() {
            this.isMobile = window.innerWidth <= 992
        }
    }
}
</script>
